(function() {
	'use strict';
	window.onload = function() {
		var bLazy = new Blazy({
			breakpoints: [
				{
						width: 368 // max-width
					, src: 'data-src-medium'
				}
			],
			success: function(element) {
				setTimeout(function() {
					var parent = element.parentNode;
					parent.className = parent.className.replace(/\bloading\b/, '');
				}, 2000);
			},
			error: function(ele, msg){
				console.log(ele.id + " - " + msg);
				console.log(this);
          }  
		});
		setTimeout(bLazy.revalidate(), 1000);
	}
})();



// WEBPACK FOOTER //
// ./modules/bLazyInit.js